<template>
  <Loader v-if="!isLoaded"/>
  <div v-else>
    <div class="with-side-panel">
      <div class="content-i">
        <div class="content-box">
          <div class="element-wrapper">

            <BackButton
                :label="$t('general.button.back')"
                :to="{ name: routeForBack }"
                marginBottom="5"/>

            <div class="d-flex justify-content-between">
              <h6 class="element-header">
                Kunden
              </h6>
            </div>

            <div class="element-box">
              <h4>{{ unemployedFullName }}</h4>
              <form @submit.prevent="submitForm">
                <div class="row mt-5">
                  <div class="col-lg-4 col-md-12 col-sm-12">
                    <p>Potenzialanalyse - PDF</p>
                    <BaseDropzone
                        v-model="documentPDF"
                        :multiple="false"
                        :height="250"
                        text="Ziehen Sie Ihre Dateien hierher oder klicken Sie, um sie auszuwählen.
                        Unterstützte Formate: PDF. Maximale Dateigröße: 8 MB."/>

                    <div v-if="document1">
                      <p class="document-header">Aktuelles Document:</p>

                      <p class="mt-2 hover-underline" type="button" @click="downloadDocument(1)">
                        <i class="os-icon os-icon-download"></i>
                        <span class="document-name">{{ document1 }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-12 col-sm-12">
                    <p>CV - Word</p>
                    <BaseDropzone
                        v-model="documentWORD"
                        :multiple="false"
                        :height="250"
                        text="Ziehen Sie Ihre Dateien hierher oder klicken Sie, um sie auszuwählen.
                        Unterstützte Formate: WORD. Maximale Dateigröße: 8 MB."/>

                    <div v-if="document2">
                      <p class="document-header">Aktuelles Document:</p>

                      <p class="mt-2 hover-underline" type="button" @click="downloadDocument(2)">
                        <i class="os-icon os-icon-download"></i>
                        <span class="document-name">{{ document2 }}</span>
                      </p>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-12 col-sm-12">
                    <p class="mt-4 mb-0">Hier kann sowohl die Auswertung des Potenzialanalyse als auch der Lebenslauf/CV
                      des Kunden
                      hochgeladen, bzw. heruntergeladen werden. Die Dokumente sind an den Kunden gebunden, das heißt:
                      hochgeladene Dokumente sind bei allen Maßnahmen des Kundens und in dessen Kartei zu finden.</p>

                    <p class="mt-3">Potenzialanalyse: Dieses Dokument kann nur vom Standortleiter/Assistenz hochgeladen
                      und verwartet werden.Hierbei handelt es sich um ein PDF.</p>

                    <p class="mt-3">Lebenslauf/CV: Der Lebenslauf/CV kann von den zugewiesenen Coaches hochgeladen
                      werden. Zur Bearbeitung bitte immer nur Word Datein hochladen</p>

                    <p class="mt-3">WICHTIG: Es kann immer nur ein CV pro Kunde hochgeladen sein. Das erneute hochladen
                      ersätz unwiederruflich das alte Dokument.</p>
                  </div>
                </div>

                <div class="d-flex justify-content-center mt-3">
                  <SaveButton
                      :label="$t('general.button.save')"
                      :loading="isSubmitting"/>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import unemployedService from '@/api/Unemployed';
import BaseDropzone from '@/components/base/BaseDropzone.vue';
import BackButton from '@/components/button/BackButton.vue';
import Loader from '@/components/Loader.vue';
import { CloseToast, ErrorToast, SuccessToast } from '@/components/VueToast';
import router from '@/router';
import { downloadFile } from '@/shared/functions';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import SaveButton from '@/components/button/SaveButton.vue';
import { useRoute } from 'vue-router';

const isLoaded           = ref(false);
const { t }              = useI18n();
const route              = useRoute();
const unemployedId       = route.params.id;
const routeForBack       = route.params.routeForBack;
const documentPDF        = ref(null);
const documentWORD       = ref(null);
const unemployedFullName = ref('');
const document1          = ref('');
const document2          = ref('');

const submitForm = async () => {
  try {

    const formData = new FormData();
    if (documentPDF.value) {
      formData.append('document1', documentPDF.value[ 0 ]);
    }
    if (documentWORD.value) {
      formData.append('document2', documentWORD.value[ 0 ]);
    }

    await unemployedService.documentUpload(route.params.id, formData);

    //await router.push({ name: 'routeForBack' });

    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  }
};

async function getUnemployedData() {
  try {
    const { data }           = await unemployedService.getUnemployed(route.params.id);
    unemployedFullName.value = data.data.fullName;
    document1.value          = data.data.document1;
    document2.value          = data.data.document2;
  } catch (error) {
    await ErrorToast(error);
  }
}

async function downloadDocument(documentNumber) {
  try {
    await downloadFile(`/unemployed/document-download/${unemployedId}/${documentNumber}`, undefined, {}, false);
  } catch (error) {
    await ErrorToast(error);
  }
}

onMounted(async () => {
  CloseToast();
  await getUnemployedData();

  isLoaded.value = true;
});
</script>

<style scoped>
.document-header {
  font-size: 18px;
  margin-top: 20px;
}

.hover-underline {
  color: var(--primary);
  font-size: 16px;
}

.hover-underline .hover-text:hover {
  text-decoration: underline;
}

.hover-underline i {
  font-size: 25px;
  margin-right: 15px;
}

.document-name {
  white-space: normal; /* Allow text to wrap to the next line */
  word-wrap: break-word; /* Break long words if necessary */
  overflow-wrap: break-word; /* Ensure words can break if they are too long */
}
</style>